var publicPath = __webpack_public_path__;
                    module.exports = {
                        symbol: publicPath + 'sprite.svg#chevron-left-left',
                        view: publicPath + 'sprite.svg#view-chevron-left-left',
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };


//////////////////
// WEBPACK FOOTER
// ./src/svg/chevron-left-left.svg
// module id = 403
// module chunks = 0